module.exports = __webpack_public_path__ + "media/assets/icons/ic-radio-button-empty-eb55600a34cb430fc6dcf3b97eca6859.svg";